export default "__VITE_ASSET__77a76f24__"